<template>
	<div
		class="flex h-full w-full flex-wrap overflow-hidden rounded bg-white outline outline-2 outline-transparent transition-all duration-500 ease-in-out hover:shadow-lg hover:shadow-gray-300 hover:outline-blue-400"
	>
		<CarbarLink
			:to="product.view.subscribe"
			:underline="false"
			class="w-full"
		>
			<div class="relative w-full">
				<CarbarTags
					v-if="hasTags"
					:tags="product.tags"
					page-type="subscribe"
					class="absolute left-2 top-2"
				/>
				<CarbarTagsPromos
					v-if="hasPromoTag"
					:discount-set="product.discount_set"
				/>
				<FilterCardImage
					:show-slide-arrows="showSlideArrows"
					:product="product"
				/>
			</div>

			<div class="flex w-full cursor-pointer flex-wrap">
				<div class="flex w-full justify-between px-3 py-3 text-left">
					<div class="flex w-full flex-col">
						<h3
							class="my-1 items-center truncate text-base font-bold uppercase"
						>
							{{ product.year }} {{ product.make }}
							{{ product.model }}
						</h3>
						<div
							class="flex h-6 items-center space-x-3 text-xsm leading-none text-gray-600"
						>
							<span
								v-if="
									product.transmission ||
									product.transmission_type
								"
								v-tippy="{ placement: 'top' }"
								content="Transmission"
							>
								{{
									product.transmission_type ??
									(`${product.transmission}`
										.toLowerCase()
										.includes('manual')
										? 'Manual'
										: 'Automatic')
								}}
							</span>
							<span
								v-if="product.body_type"
								v-tippy="{ placement: 'top' }"
								content="Body type"
							>
								{{ product.body_type }}
							</span>
							<span
								v-if="product.fuel_type || product.fuel"
								v-tippy="{ placement: 'top' }"
								content="Fuel type"
							>
								{{ product.fuel ?? product.fuel_type }}
							</span>
						</div>
						<VehicleDetailsLocations
							:location="product.location"
							:available-locations="product.available_locations"
						/>
					</div>
				</div>
			</div>

			<div class="flex w-full border-t px-3 py-3">
				<div class="flex w-full justify-between">
					<div class="flex flex-col justify-center">
						<div
							v-if="
								isLoggedIn &&
								product?.compare_pricing?.price &&
								!isNovatedUser
							"
							class="text-xs text-gray-575 line-through"
						>
							{{ formatCurrency(product.compare_pricing.price) }}
						</div>
						<div class="flex gap-x-1 leading-none">
							<p
								v-if="product.pricing.marker"
								class="m-0 font-heading text-2xl font-bold leading-none text-gray-600 line-through"
							>
								{{ formatCurrency(product.pricing.marker) }}
							</p>
							<p
								class="m-0 font-heading text-2xl font-bold leading-none text-heading"
							>
								{{
									product.pricing.price > 0
										? formatCurrency(product.pricing.price)
										: ''
								}}
							</p>
							<span class="pt-[0.6rem] text-xsm text-gray-600">
								{{
									product.pricing.price > 0 &&
									product.pricing.type.toLowerCase() ===
										'weekly'
										? 'per week'
										: ''
								}}
							</span>
						</div>
					</div>
				</div>
			</div>
		</CarbarLink>
	</div>
</template>

<script setup>
import CarbarTags from '@/components/badges/CarbarTags.vue'
import CarbarTagsPromos from '@/components/badges/CarbarTagsPromos.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import FilterCardImage from '@/components/product-catalog/cards/FilterCardImage.vue'
import VehicleDetailsLocations from '@/components/vehicle-details/VehicleDetailsLocations.vue'

const props = defineProps({
	product: {
		type: Object,
		required: false,
	},
	showSlideArrows: {
		type: Boolean,
		required: false,
		default: false,
	},
})

const hasTags = computed(() => {
	return (
		Object.values(props.product?.tags).filter((value) => value === true)
			.length >= 1
	)
})

const hasPromoTag = computed(() => {
	return Object.keys(props.product?.discount_set).length > 0
})
</script>
